import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Typography, Alert, CircularProgress } from '@mui/material';
import { stripeService } from '../../services/api';

const AssinaturaStripe = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAssinar = async () => {
    setLoading(true);
    setError('');
    try {
      const resp = await stripeService.createCheckoutSession();
      const url = resp?.data?.url || resp?.data?.data?.url;
      if (!url) throw new Error('Não foi possível iniciar o checkout');
      window.location.href = url;
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'Erro ao iniciar assinatura');
    } finally {
      setLoading(false);
    }
  };

  const handleAtualizarCartao = async () => {
    setLoading(true);
    setError('');
    try {
      const resp = await stripeService.createPortalSession();
      const url = resp?.data?.url || resp?.data?.data?.url;
      if (!url) throw new Error('Não foi possível abrir o portal de pagamento');
      window.location.href = url;
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'Erro ao abrir portal de pagamento');
    } finally {
      setLoading(false);
    }
  };

  const handleVerificarPagamento = async () => {
    setLoading(true);
    setError('');
    try {
      await stripeService.getMinhaAssinatura();
      window.location.href = '/app/dashboard';
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'Não foi possível verificar agora');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 520, mx: 'auto', mt: 4 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Assinatura Trajetus
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Plano mensal: R$ 59,99
          </Typography>

          {error ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          ) : null}

          <Button
            variant="contained"
            fullWidth
            onClick={handleAssinar}
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Redirecionando...
              </>
            ) : (
              'Assinar com Stripe'
            )}
          </Button>

          <Button
            variant="outlined"
            fullWidth
            onClick={handleAtualizarCartao}
            disabled={loading}
            sx={{ mt: 1 }}
          >
            Atualizar cartão
          </Button>

          <Button
            variant="text"
            fullWidth
            onClick={handleVerificarPagamento}
            disabled={loading}
            sx={{ mt: 1 }}
          >
            Já paguei / Verificar
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AssinaturaStripe;
